import { render, staticRenderFns } from "./DashboardTributos.vue?vue&type=template&id=0d3a4904&"
import script from "./DashboardTributos.vue?vue&type=script&lang=js&"
export * from "./DashboardTributos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\MasterBranches\\Maintenance_06.04\\Fontes\\corp\\produto\\wes\\WebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d3a4904')) {
      api.createRecord('0d3a4904', component.options)
    } else {
      api.reload('0d3a4904', component.options)
    }
    module.hot.accept("./DashboardTributos.vue?vue&type=template&id=0d3a4904&", function () {
      api.rerender('0d3a4904', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "content/components/Tributos/DashboardTributos.vue"
export default component.exports